import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles, Copy, RefreshCw, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg, copyText, fmtDateTime } from "@/lib/api";

const SECTIONS = [["priorita", "Priorità"], ["rischi", "Rischi"], ["prossimi_passi", "Prossimi passi"]];

const asText = (s) => [`Situazione\n${s.situazione}`, ...SECTIONS.map(([k, l]) => `${l}\n${(s[k] || []).map((x) => `- ${x}`).join("\n") || "- Nessuno"}`)].join("\n\n");

export const AiSummaryDialog = ({ open, onOpenChange, client }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const generate = async () => {
    setBusy(true);
    try { setS((await api.post(`/clients/${client.id}/ai/riassunto`)).data); }
    catch (e) { toast.error(errMsg(e, "Generazione non riuscita")); }
    finally { setBusy(false); }
  };
  useEffect(() => {
    if (!open) return;
    api.get(`/clients/${client.id}/ai/riassunto`).then((r) => (r.data?.situazione ? setS(r.data) : generate()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, client.id]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto rounded-2xl core-scroll" data-testid="ai-summary-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black text-[#0A1128] flex items-center gap-2"><Sparkles className="h-5 w-5 text-[#E8173A]" />Riassunto AI</DialogTitle>
          <DialogDescription>{client.ragione_sociale}{s?.created_at && ` · aggiornato il ${fmtDateTime(s.created_at)} da ${s.created_by_nome}`}</DialogDescription>
        </DialogHeader>
        {busy && !s && <div className="flex items-center gap-2 text-[#0A1128] py-10 justify-center" data-testid="ai-summary-loading"><Loader2 className="h-5 w-5 animate-spin" />Sto analizzando task, appuntamenti, PED e feedback...</div>}
        {s && (
          <div className={`space-y-5 ${busy ? "opacity-50" : ""}`} data-testid="ai-summary-content">
            <section><h4 className="text-xs font-bold uppercase tracking-wider text-[#E8173A] mb-1">Situazione</h4><p className="text-[#0A1128]" data-testid="ai-summary-situazione">{s.situazione}</p></section>
            {SECTIONS.map(([k, l]) => (
              <section key={k} data-testid={`ai-summary-${k}`}>
                <h4 className="text-xs font-bold uppercase tracking-wider text-[#E8173A] mb-1">{l}</h4>
                {s[k]?.length ? <ul className="list-disc pl-5 space-y-1 text-[#0A1128]">{s[k].map((x, i) => <li key={i}>{x}</li>)}</ul> : <p className="text-slate-600 text-sm">Nessun elemento.</p>}
              </section>
            ))}
            <div className="flex gap-2 pt-2">
              <Button variant="outline" onClick={async () => { await copyText(asText(s)); toast.success("Riassunto copiato"); }} className="rounded-full font-bold" data-testid="ai-summary-copy"><Copy className="h-4 w-4 mr-1.5" />Copia</Button>
              <Button onClick={generate} disabled={busy} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="ai-summary-regenerate">{busy ? <Loader2 className="h-4 w-4 animate-spin mr-1.5" /> : <RefreshCw className="h-4 w-4 mr-1.5" />}Rigenera</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
